<template>
  <transition name="slide-fade">
    <div id="aboutusHolder">
      <!--<div class=" uk-background-secondary uk-light" style="padding: 20px; color: rgb(197,179,88) !important;">
        <div class="uk-container uk-container-small ">
          <p class="uk-text-center uk-text-lead@l uk-text-large@l">
            We take pride in being a support source for the community and our employees.
            <br>
            &lt;!&ndash;<span class="uk-text-small uk-text-muted">
                Late Applicant will be considered but will attract late fees.
              </span>&ndash;&gt;
            &lt;!&ndash;<br><br>
            <a href="#" class="uk-button uk-button-default">Learn More</a>&ndash;&gt;
          </p>
        </div>
      </div>-->

      <div class="uk-padding">
        <h1 class="uk-heading-divider uk-text-center specHeading"><span>The Future Northern Caribbean University</span></h1>

        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@m" uk-grid>
            <div>
              <img class="uk-align-center" src="../assets/vision_mission.jpg" alt="">
            </div>
            <div>
              <h3 class="uk-heading-divider uk-text-center specHeading"><b>Vision Statement</b></h3>
              <span class="uk-text-muted">
                Northern Caribbean University will be the premier institution of higher learning in the Northern
                Caribbean region with a commitment to offering innovative, quality, accessible Christ- centered education.
              </span>
              <h3 class="uk-heading-divider uk-text-center specHeading"><b>Mission Statement</b></h3>
              <span class="uk-text-muted">
                The mission of Northern Caribbean University, a Seventh-day Adventist institution, is to improve the
                human condition by providing Christ-centered education through academic excellence, values-based focus,
                spiritual and physical development, social interaction, and a strong work ethic thereby equipping each
                student for committed professional service to all people, and to God.
              </span>
            </div>
          </div>

        </div>
      </div>
      <br/>
     <!-- <presidentmessage></presidentmessage>-->

      <div class="uk-container uk-container-small">
        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" uk-grid>
          <div class="uk-flex-last@s uk-card-media-right uk-cover-container">
            <img src="../assets/commit_statement.jpg" alt="" uk-cover>
            <canvas width="600" height="400"></canvas>
          </div>
          <div>
            <div class="uk-card-body">
              <h3 class="uk-card-title uk-heading-divider"><b>Commitment Statement</b></h3>
              <p>
                Northern Caribbean University commits to act justly, love mercy, live in integrity,
                and walk humbly with our God.’ (Adapted from Micah 6:8)
              </p>
            </div>
          </div>
        </div>

        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" uk-grid>
          <div class="uk-card-media-left uk-cover-container">
            <img src="../assets/value_statement.jpg" alt="" uk-cover>
            <canvas width="600" height="400"></canvas>
          </div>
          <div>
            <div class="uk-card-body">
              <h3 class="uk-card-title uk-heading-divider"><b>Value Statement</b></h3>
              <p>
                Ubi Semper Discimus – Where Learning Never Ends
              </p>
            </div>
          </div>
        </div>

        <div class="uk-card uk-card-default uk-grid-collapse uk-child-width-1-2@s uk-margin" uk-grid>
          <div class="uk-flex-last@s uk-card-media-right uk-cover-container">
            <img src="../assets/international.jpeg" alt="" uk-cover>
            <canvas width="600" height="400"></canvas>
          </div>
          <div>
            <div class="uk-card-body">
              <h3 class="uk-card-title uk-heading-divider"><b>Strategy</b></h3>
              <p>
                The continuous review of the alignment of human and financial resources as a
                method of measuring the effective implementation of the NCU Mission and core
                values in its operations.
              </p>
            </div>
          </div>
        </div>
      </div>
<br/>
      <div class="uk-padding uk-background-muted">
        <h1 class="uk-heading-divider uk-text-center specHeading"><b>Our Core Values</b></h1>
        <div class="uk-container uk-container-small">
          <div class="uk-child-width-1-2@s" uk-grid>
            <div>
              <div class="uk-child-width-1-1@l" uk-grid>
                <p class="uk-text-uppercase uk-text-large">
                  - Accountability <br>
                  - Fairness <br>
                  - Forgiveness <br>
                  - Integrity <br>
                  - Respect <br>
                  - Mercy <br>
                  - Service Excellence <br>


                </p>

              </div>
            </div>
            <div>
              <div class="uk-visible@s uk-child-width-1-2@s uk-child-width-1-2@m uk-child-width-1-2@l" uk-grid>
                <div>
                  <img class="uk-border-circle" src="../assets/value1.jpg" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/value2.jpg" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/value3.jpg" width="200" height="200" alt="Border circle">
                </div>
                <div>
                  <img class="uk-border-circle" src="../assets/value4.jpg" width="200" height="200" alt="Border circle">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </transition>
</template>

<script>




  export default {
        name: "futurencu",
    components: {


    },
    mounted(){
      window.scrollTo(0, 0);
    },
    metaInfo: {
      // Children can override the title.
      title: 'NCU Future',
      // Result: My Page Title ← My Site
      // If a child changes the title to "My Other Page Title",
      // it will become: My Other Page Title ← My Site
      //titleTemplate: '%s ← My Site',
      // Define meta tags here.
      meta: [
        {'http-equiv': 'Content-Type', content: 'text/html; charset=utf-8'},
        {name: 'viewport', content: 'width=device-width, initial-scale=1'},
        {name: 'description', content: 'The future of Northern Caribbean University '}
      ]
  }
    }
</script>

<style scoped>
  @media screen and (max-width:600px){


    h1{
      font-size: 1.4em !important;
    } h3{
      font-size: 1.3em !important;
    }
    p{
      font-size: 0.8em !important;
    }


  }
</style>
